"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.number.constructor");
var _couponCode = _interopRequireDefault(require("@/api/activity/couponCode.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'expandList',
  components: {},
  props: {
    actId: {
      type: Number,
      default: ''
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newVal) {
        console.log('actId', newVal);
        // 有actId时选中，无actId时不选
        if (newVal == 0) return;
        newVal = newVal.toString();
        this.searchForm.activityId = newVal && newVal != 'null' && newVal != 'NaN' ? newVal : '';
        this.searchForm2.activityId = newVal && newVal != 'null' && newVal != 'NaN' ? newVal : '';
        this.searchForm.page = 1;
        this.fetchList(newVal);
      }
    }
  },
  data: function data() {
    return {
      actList: [],
      shoplist: [],
      loading: false,
      searchForm: {
        activityId: '',
        status: '',
        exchangeCode: '',
        storeId: '',
        page: 1,
        limit: 10,
        total: 0,
        mobile: '',
        cardNo: ''
      },
      tableData: [],
      couponList: [],
      showUserDialog: false,
      // 控制弹窗显示
      exchangeCode: [],
      searchForm2: {
        activityId: '',
        status: '',
        exchangeCode: '',
        storeId: '',
        verifyStatus: '',
        page: 1,
        limit: 10,
        total: 0,
        mobile: '',
        cardNo: ''
      },
      downloadLoading: false
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    getActList: function getActList() {
      var _this = this;
      var data = {
        startTime: '',
        endTime: '',
        keywords: '',
        page: 1,
        limit: 9999,
        total: 0
      };
      _couponCode.default.getActList(data).then(function (res) {
        _this.actList = res.records || [];
      });
    },
    dateFormat2: function dateFormat2(date, format) {
      var d = date instanceof Date ? date : new Date(date);
      if (isNaN(d.getTime())) return '';
      var map = {
        'yyyy': d.getFullYear(),
        'MM': ('0' + (d.getMonth() + 1)).slice(-2),
        'dd': ('0' + d.getDate()).slice(-2),
        'HH': ('0' + d.getHours()).slice(-2),
        'mm': ('0' + d.getMinutes()).slice(-2),
        'ss': ('0' + d.getSeconds()).slice(-2)
      };
      var fmt = format || 'yyyy-MM-dd HH:mm:ss';
      Object.keys(map).forEach(function (k) {
        fmt = fmt.replace(k, map[k]);
      });
      return fmt;
    },
    download: function download() {
      var _this2 = this;
      this.downloadLoading = true;
      var params = {
        activityId: this.searchForm.activityId,
        exchangeCode: this.searchForm.exchangeCode,
        storeId: this.searchForm.storeId,
        status: this.searchForm.status,
        expandId: this.searchForm.expandId,
        mobile: this.searchForm.mobile,
        cardNo: this.searchForm.cardNo
      };
      _couponCode.default.exportCodeData(params).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '券码列表.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this2.downloadLoading = false;
      });
    },
    changeTime: function changeTime(e) {
      console.log(e);
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
    },
    fetchList: function fetchList() {
      var _this3 = this;
      this.loading = true;
      _couponCode.default.getCodeList(this.searchForm).then(function (res) {
        res.records.forEach(function (item) {
          if (item.exchangeTime) {
            item.exchangeTimeFmt = _this3.dateFormat2(item.exchangeTime);
          }
        });
        _this3.tableData = res.records || [];
        _this3.searchForm.total = res.total || 0;
      }).finally(function () {
        _this3.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.searchForm = {
        expandId: '',
        page: 1,
        limit: 10,
        total: 0,
        mobile: '',
        cardNo: ''
      }, this.fetchList();
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange2: function handlePageChange2(newPage) {
      this.searchForm.page2 = newPage;
      this.getUserList();
    },
    handleSizeChange2: function handleSizeChange2(newSize) {
      this.searchForm2.limit = newSize;
      this.searchForm2.page = 1;
      this.getUserList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    handleDetail: function handleDetail(row) {
      this.searchForm2.status = '';
      this.searchForm2.page = 1;
      this.searchForm2.exchangeCode = row.exchangeCode;
      this.searchForm2.mobile = row.mobile;
      this.searchForm2.cardNo = row.cardNo;
      this.getUserList();
      this.showUserDialog = true;
    },
    getUserList: function getUserList() {
      var _this4 = this;
      _couponCode.default.getCouponList(this.searchForm2).then(function (res) {
        _this4.couponList = res.records || [];
        _this4.searchForm2.total = res.total || 0;
      });
    },
    getShopList: function getShopList() {
      var _this5 = this;
      _couponCode.default.getStoreList().then(function (res) {
        _this5.shoplist = res;
      });
    }
  },
  mounted: function mounted() {
    this.getActList();
    this.fetchList();
    this.getShopList();
  }
};